import React from 'react';
import FeaturedCategories from './FeaturedCategories';

/**
 * HomepageCategories — wraps FeaturedCategories with premium homepage
 * section styling (black/gold marketplace feel). Sits between the
 * Rewards/Ambassador section and Discovery.
 */
const HomepageCategories = () => (
  <section
    className="relative bg-black py-16 lg:py-20 border-t border-white/[0.04]"
    data-testid="homepage-categories-section"
  >
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(212,175,55,0.06),transparent_70%)]" />
    <div className="relative max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8">
      <FeaturedCategories
        title="Order what you love"
        subtitle="Explore the marketplace"
      />
    </div>
  </section>
);

export default HomepageCategories;
